import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SignUpUserHeader from "../../components/header/SignUpUserHeader";
import './UserOnboardingPage.css'; 
import tooltip from "../../assets/images/questionTooltip.svg";
import { Col, Row } from "antd";

const PersonalInfo = ({ setOnboardingData, onboardingData }) => {
  const [personalInfo, setPersonalInfo] = useState({
    name: onboardingData.personalInfo?.name || '',
    age: onboardingData.personalInfo?.age || '',
    dob: onboardingData.personalInfo?.dob || '',
    nickName: onboardingData.personalInfo?.nickName || '',
    gender: onboardingData.personalInfo?.gender || '',
  });
  const [showDobTooltip, setShowTooltip] = useState(false);  
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPersonalInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setOnboardingData((prevData) => {
      const newData = {
        ...prevData,
        personalInfo,
      };
      return newData;
    });
    localStorage.setItem('personalInfo',JSON.stringify(personalInfo));
 

    navigate('/onboarding/contact-info');
  };

  const handleBack = () => {
    navigate('/onboarding/terms-and-conditions');
  };

  return (
    <Row className="welcome-onboarding-row" style={{ background: "#fefcfe" }}>
      <Col lg={24}>
        <SignUpUserHeader />
      </Col>
      <Row gutter={24} className="welcome-onboarding-row-card-container">
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          className="welcome-onboarding-inner-content-col"
        >
          <div className="onboarding-step">
            <h1>Personal Information</h1>
            <form onSubmit={handleSubmit}>
              <label htmlFor="name">
                Full Name <i className="required-input">*</i>
              </label>
              <input
                type="text"
                name="name"
                value={personalInfo.name}
                onChange={handleChange}
                placeholder="Full Name"
                required
              />
              <label htmlFor="age">
                Date of Birth
                <img
                  src={tooltip}
                  alt="tooltip"
                  className="tooltip-icon"
                  onMouseOver={() => setShowTooltip(true)}
                  onMouseOut={() => setShowTooltip(false)}
                />
                {showDobTooltip && (
                  <div className="tooltip">
                    <p>
                      <strong>Why do we need this?</strong>
                    </p>
                    <p>
                      By knowing your age, we can better design your individual
                      experience on MyFriend. Content and suggestions will be
                      more relevant and accurate to you.
                    </p>
                  </div>
                )}
              </label>
              <select
                name="age"
                value={personalInfo.age}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select your age
                </option>
                <option value="18-24">18-24</option>
                <option value="25-34">25-34</option>
                <option value="35-44">35-44</option>
                <option value="45-54">45-54</option>
                <option value="55-64">55-64</option>
                <option value="65-74">65-74</option>
                <option value="75+">75+</option>
              </select>
              <label htmlFor="nickName">
                What would you like us to call you?{" "}
              </label>
              <input
                type="text"
                name="nickName"
                value={personalInfo.nickName}
                onChange={handleChange}
                placeholder="Nickname"
              />
              <label htmlFor="gender">
                Select Your Gender <i className="required-input">*</i>
              </label>
              <select
                name="gender"
                value={personalInfo.gender}
                onChange={handleChange}
                required
              >
                <option value="" disabled>
                  Select Your Gender
                </option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="trans-male">Transgender-Male</option>
                <option value="trans-female">Transgender-Female</option>
                <option value="non-binary">Non-binary</option>
                <option value="prefer-not-to-say">Prefer not to say</option>
              </select>
              <div className="button-container">
                <button
                  type="button"
                  onClick={handleBack}
                  className="back-button"
                >
                  Back
                </button>
                <button type="submit" className="next-button">
                  Next
                </button>
              </div>
            </form>
          </div>
        </Col>
      </Row>
    </Row>
  );
};

export default PersonalInfo;